"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebCall = void 0;
const tslib_1 = require("tslib");
var voice_class_1 = require("./voice-class");
Object.defineProperty(exports, "WebCall", { enumerable: true, get: function () { return tslib_1.__importDefault(voice_class_1).default; } });
tslib_1.__exportStar(require("./voice-class"), exports); // If you want to export its types
